import Accordion from "components/accordion";
import { TaskGroup } from "./task-group";
import { guidGenerator } from "shared/helpers";
import { useTasksByStatus } from "../hooks/use-tasks-by-status";

const CodingDetail = ({ tasks }) => {
    const labelType = {
        current: "Current",
        original: "Original",
        redo: "Redo",
    };

    const groupedTasks = useTasksByStatus(tasks);

    return (
        <Accordion
            className="-no-indent"
            closeInactive={true}
        >
            {groupedTasks.map((task, i) => {
                const label = i === 0 ? labelType.current : groupedTasks.length - 1 === i ? labelType.original : labelType.redo;

                return (
                    <div
                        label={label}
                        //TODO: fix below line. New key is generated every time component re-renders. Key must be stable.
                        key={guidGenerator()}
                    >
                        {task.map((item) => {
                            return (
                                <TaskGroup
                                    //Same here
                                    key={guidGenerator()}
                                    task={item}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </Accordion>
    );
};

export default CodingDetail;
